const studies = {
  completion_header: {
    default: "Algo salió mal",
    qualified: "¡Felicidades! Ha finalizado la encuesta con éxito",
    non_qualified: "No calificó para esta encuesta",
    out_of_quota: "Esta encuesta llegó a su límite y ya se cerró",
  },
};

export default studies;
